import { useState } from "react";
import { useAuthContext } from '@/context/AuthContext';
import {userManager} from '@/components/authentication/keycloak.js';

const useAnalyzeCV = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);

    const getAnalyzeCV = async (file) => {
        setLoading(true);
        setError(null);
        const user = await userManager.getUser();

        try {
            const formData = new FormData();
            formData.append("resume", file, file.name);

            const response = await fetch(
                `${window.ENV.BACKEND_URL}/api/secured/admin/prospect/analyzeCV`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${user.access_token}`,
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                const errorJson = await response?.json();
                console.error("Error response received:", errorJson);
                throw errorJson
            }

            // const data = await response.json();
            const data = response?.data || response.json() || true;
            setResponse(data);
            return { data, error: null };
        } catch (err) {
            console.error("getAnalyzeCV error:", err, err.detail);
            setError(err.message || err.detail);
            return { data: null, error: err };
        } finally {
            setLoading(false);
        }
    };

    const resetError = () => setError(null);

    return { getAnalyzeCV, loading, error, response, resetError };
};

export default useAnalyzeCV;
